import ApiService from "../../helpers/api.helpers";

export async function getUserReportsForOrganization(organizationID) {
	const api = new ApiService();

	return api.get(`/users/reports/${organizationID}`);
}
